<template>
    <div>
        <div v-if="!hasDisVersion" @click="displayVersion">
        <slot></slot>
    </div>
    <div v-transfer-dom v-else="" class="cu-modal bottom-modal show map2pay" @click="displayVersion">
        <div class="cu-dialog view" @click.stop="">
            <div class="flex align-end justify-end padding text-xxl">
                <div class="cuIcon-close" @click.stop="displayVersion"></div>
            </div>
            <div class="flex-col relative section_6">
            <div class="flex-col group_4">
                <div class="flex-col justify-start relative group_5">
                    <div class="flex-col relative section_8">
                        <div>
                    <div v-if="hasInBusiness==1" class="tab-2025 flex-row items-center justify-center">
                            <div @click="tabs(2)"
                                 class="flex-col justify-center items-center tab-2025-2 tab-left2" :class="tabCurrent==2?'tab-active':''">
                                <span>企业版</span></div>
                            <div @click="tabs(3)"
                                 class="flex-col justify-center items-center tab-2025-2 tab-right2" :class="tabCurrent==3?'tab-active':''">
                                <span>旗舰版</span></div>
                        </div>
                    <template v-else="">
                        <div class="tab-2025 flex-row items-center justify-center">
                            <div @click="tabs(1)"
                                class="flex-col items-center justify-center tab-2025-3 tab-left3" :class="tabCurrent==1?'tab-active':''">
                                <span>个人版</span>
                            </div>
                            <div @click="tabs(2)"
                                 class="flex-col justify-center items-center tab-2025-3 tab-center" :class="tabCurrent==2?'tab-active':''">
                                <span>企业版</span></div>
                            <div @click="tabs(3)"
                                 class="flex-col justify-center items-center tab-2025-3 tab-right3" :class="tabCurrent==3?'tab-active':''">
                                <span>旗舰版</span></div>
                        </div>
                    </template>  
                </div>
                        <div class="flex-col justify-start relative group_6">
                            <template v-if="tabCurrent==2">
                                <div class="flex-row">
                                    <div class="flex-col equal-division-item section_9 space-y-10"
                                         :class="[userinfo.vipType==21?'useed':'',selected==21?'selected':'']"
                                         @click="userClickChecked(21)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">企业基础版</span>
                                        </div>
                                        <span class="font_6 text_11">纯净无广告，适合文化品牌活动</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_10 space-y-10"
                                         :class="[userinfo.vipType==22?'useed':'',selected==22?'selected':'']"
                                         @click="userClickChecked(22)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">企业标准版</span>
                                        </div>
                                        <span class="font_6 text_12">大容载，适合企业、政府、媒体</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_11 space-y-10"
                                         :class="[userinfo.vipType==23?'useed':'',selected==23?'selected':'']"
                                         @click="userClickChecked(23)">
                                        <div class="flex-col group_7 space-y-4">
                                            <img
                                                    class="self-center image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="self-start font_1 text_10 text-cut">企业高级版</span>
                                        </div>
                                        <span class="font_6 text_13">超大容载，适合大规模全国活动</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="tabCurrent==3">
                                <div class="flex-row">
                                    <div class="flex-col equal-division-item section_9 space-y-10"
                                         :class="[userinfo.vipType==31?'useed':'',selected==31?'selected':'']"
                                         @click="userClickChecked(31)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">旗舰版</span>
                                        </div>
                                        <span class="font_6 text_11">海量容载，超大规模活动比赛...</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_10 space-y-10"
                                         :class="[userinfo.vipType==99?'useed':'',selected==99?'selected':'']"
                                         @click="userClickChecked(99)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">私有化部署</span>
                                        </div>
                                        <span class="font_6 text_12">本地部署，多元化部署解决方案</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_10 space-y-10" 
                                    style="background: transparent;">&nbsp;</div>
                                </div>
                            </template>
                            <div v-else="" class="flex-row xxx-1">
                                <div class="flex-col equal-division-item section_9 space-y-10"
                                     :class="[userinfo.vipType==0?'useed':'',selected==0?'selected':'']"
                                     @click="userClickChecked(0)">
                                    <div class="flex-col items-center space-y-4">
                                        <img class="image_6" src="https://assets.pfotoo.com/images/version/0.png" />
                                        <span class="font_1">免费版</span>
                                    </div>
                                    <span class="font_5--1 text_11">适合测试或社团协会、个人活动</span>
                                </div>
                                <div class="flex-col equal-division-item_2 section_10 space-y-10"
                                     :class="[userinfo.vipType==11?'useed':'',selected==11?'selected':'']"
                                     @click="userClickChecked(11)">
                                    <div class="flex-col items-center space-y-4">
                                        <img class="image_6" src="https://assets.pfotoo.com/images/version/11.png" />
                                        <span class="font_1">基础版</span>
                                    </div>
                                    <span class="font_5--1 text_11">
            适用收集投票评选的小微活动
            <br />
          </span>
                                </div>
                                <div class="flex-col equal-division-item_2 section_11 space-y-10"
                                     :class="[userinfo.vipType==12?'useed':'',selected==12?'selected':'']"
                                     @click="userClickChecked(12)">
                                    <div class="flex-col group_5--1 space-y-4">
                                        <img
                                                class="self-center image_6"
                                                src="https://assets.pfotoo.com/images/version/12.png"
                                        />
                                        <span class="self-start font_1">高级版</span>
                                    </div>
                                    <span class="font_5--1 text_12">适用大文件无压缩中小型活动</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="flex align-center justify-center relative section_13 view">
                <div v-if="selected>0 && selected<99" @click="showPrices"
                     class="flex-row justify-between items-center section_14" style="width: 100%;" >
                    <div class="flex-row">
                        <span class="self-center font_8">¥</span>
                        <span class="text_22">{{this.prices?this.prices[0].amount/100:'--'}}</span>
                        <span class="self-start font_8 text_24">起</span>
                    </div>
                    <div class="flex-col justify-start items-center button_2"><span class="font_4 text_23">购买</span></div>
                </div>
                <div v-else="" class="button-user" @click="servicesEvent">{{selected==0?'免费版无需开通':'如有需要联系客服升级'}}</div>
            </div>
        </div>
        </div>
        
    </div>
    <services ref="services"></services>
        <pricesDialog ref="pricesDialog" :prices="prices" @event="pricesDialogEvent"
                      :userinfo="userinfo" :hasManager="hasManager" :hasUsePayBut="hasUsePayBut"
                      :selected="selected" :VERSIONS="VERSIONS"></pricesDialog>
        <payedDialog ref="payedDialog" @event="payedDialogEvent"></payedDialog>
        <dialogCode ref="dialogCode" @event="payedDialogEvent"></dialogCode>
    </div>
</template>
<script>
  import App from '../util/comfun'
  import services from './service-dialog.vue'
  import pricesDialog from './prices-dialog.vue'
  import payedDialog from './payed-dialog.vue'
  import dialogCode from './checkout/dialogCode.vue'
  import TransferDom from '../util/transfer-dom'
  export default {
    props:{
        tabCurrent:Number,
    },
    data () {
      return {
            hasDisVersion:false,
            userinfo:null,
            selected:-1,
            hasInBusiness:0,
            VERSIONS:{},
            prices:null,
            hasManager:false,
            hasUsePayBut:false,
      }
    },
    components:{
        services,
      pricesDialog,
      payedDialog,
      dialogCode,
    },
    directives: { TransferDom },
    methods:{
      displayVersion(){
        this.userinfo=App.cache('userinfo')
        this.VERSIONS=App.cache('VERSIONS')
        this.selected=this.tabs(this.tabCurrent)



        this.hasDisVersion=!this.hasDisVersion
      },

    tabs(val){
      this.tabCurrent = val
      if (val == 3) {
        this.checked(31)
      } else if (val == 2) {
        this.checked(21)
      } else {
        this.checked(12)
      }
    },
      async userClickChecked(val){
        this.selected=val
        if(this.selected>0){
          await this.queryPayServiceItemList()
          //hasUsePayBut && selected>0 && selected<99
          if(this.selected>0 && this.selected<99){
            this.showPrices()
          }
        }
      },
      checked(val){
        this.selected=val
        if(this.selected>0){
          this.queryPayServiceItemList()
        }
      },
      async queryPayServiceItemList(){
        this.$refs.pricesDialog.hide()
        let res=await App.demand('/activity/payment/queryPayServiceItemList','POST',{
          pageIndex: 1,
          pageSize: 100,
          paymentType: 'versionVip',
          versionType:this.selected,
        })
        //renewalExclusive=1 续费专享
        let prices=res.data.list||[]
        if(this.userinfo.vipType==0){//过滤掉续费专享
          prices=prices.filter(p=>{
            return p.renewalExclusive==0
          })
        }
        this.prices=prices||null
        console.info('this.prices',this.prices)
      },
      services(){
        this.$refs.services.show()
      },
      servicesEvent(){
        if(this.selected==0){
          return this.$message({ message: '免费版无需开通', type: "info" });
        }
        this.services()
      },
      showPrices(){
        this.$refs.pricesDialog.show()
      },
      itemsDisplay(index){
        let item=this.items[index]
        item.display=!item.display
        this.items.splice(index, 1, item);
      },
      pricesDialogEvent(e){
        console.log(e)
        if(e.payed){
          this.$refs.payedDialog.show({
            "upinfo":e.item.description+('')+this.VERSIONS[this.selected].versionName
          })
        }
        if(e.payParams){
          this.$refs.dialogCode.show(e)
        }
        this.$refs.pricesDialog.hide()
      },
      payedDialogEvent(e){
        if(e.act=='services'){
          this.$refs.services.show()
        }else if(e.act=='reFlush'){
          this.getUserInfo()
        }
      },
      usePayBut(){
        let hasiPhone=window.navigator.userAgent.toLocaleLowerCase().indexOf('iphone')>-1
        if(this.options.from=='wxlite' && hasiPhone) {
          //return this.hasManager
          return false
        }
        return true
      },
    },
    created(){

    },
  }
</script>
<style>
@import url('../../static/icon.css');
    @import url('../pages/version-tabs.css');
    @import url('./map2pay.css');
    .map2pay.cu-modal.bottom-modal{
        z-index: 99999;
    }
</style>


// WEBPACK FOOTER //
// src/components/map2pay.vue